export const SET_SETTLEMENTS_FILTER = 'SET_SETTLEMENTS_FILTER';
export const SET_SETTLEMENTS_LIST = 'SET_SETTLEMENTS_LIST';
